import React,{useEffect, useState} from 'react'
import {BellFilled,CrownTwoTone
} from '@ant-design/icons';
import { message,Button, Menu,notification,Avatar,Radio, Space, Table, Tag } from 'antd';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  redirect,
  useNavigate,useLocation
 } from "react-router-dom";
import { getAuth,signOut} from 'firebase/auth'
import {useSelector} from 'react-redux'


export default function Navbar() {

  const navigate = useNavigate()
  const [showDrawer,setShowDrower] = useState(true)
  const [currentMenu,setCurrentMenu] = useState('DASHBOARD')
  const user = useSelector(state=>state.login.oauthDetails)
  const configs = useSelector(state=>state.configs)
  const location = useLocation();
  var openNotificationWithIcon = (type,msg,desc) => {
    notification[type]({
      message: msg,
      description:desc
        
    });
  };
  useEffect(()=>{
    // console.log('refux state changed for navbar',user)
  },[user])
  useEffect(()=>{
    
  },[location])

  const handleLogout = ()=>{
    const auth = getAuth();
  signOut(auth).then(() => {
    openNotificationWithIcon('success',
    'Logout Success',
    'You have been logged out successfully !'
    )
    navigate('/')
  }).catch((error) => {
    openNotificationWithIcon('error',
    'Service error',
    error.errorMessage
    )
    });
  };
  const toggleSidebar  = ()=>{
    const menu = document.getElementById("drawer-navigation")
  
    if (showDrawer) {
      menu.classList.remove('hidden')
      setShowDrower(false)
    } else {
      menu.classList.add('hidden')
      setShowDrower(true)
    }
  };
  const navigateTo = (path)=>{
    navigate(path)
    toggleSidebar()
  }
  return (
    <div>  {!showDrawer && <div onClick={()=>{toggleSidebar()}} className='drawerBGTransaparent'></div>}

    <div id="drawer-navigation" class="hidden transform ease-in-out fixed z-40 h-full inset-0 transition-all delay-500  overflow-y-auto bg-white w-80 dark:bg-gray-800" tabindex="-1" aria-labelledby="drawer-navigation-label">
      <span className='mt-2 p-2'>
    {user.photoURL ?
            <Avatar src={user.photoURL} />:
          <Avatar style={{ backgroundColor: '#f56a00' ,textTransform:'uppercase'}}>{user.email?user.email[0]:'A'}</Avatar>}</span>
    <h5 id="drawer-navigation-label" class="p-2 text-base font-semibold text-gray-500 uppercase dark:text-gray-400">{user.displayName ? user.displayName :user.email}</h5>
    <button onClick={()=>{toggleSidebar()}} type="button" data-drawer-dismiss="drawer-navigation" aria-controls="drawer-navigation" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
        <span class="sr-only">Close menu</span>
    </button>
  <div class="py-4 overflow-y-auto">
      <ul class="space-y-2">
         <li onClick={()=>{navigateTo('/dashboard/default')}}>
            <a  class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
               <span class="flex-1 ml-3 whitespace-nowrap">Dashboard</span>
              {configs.membership.planType!=='FREE' &&  <CrownTwoTone style={{marginLeft:5}} twoToneColor='#FFD700'/>}
               {configs.membership.planType==='FREE' &&    <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800 bg-gray-200 rounded-full dark:bg-gray-700 dark:text-gray-300">FREE</span> }
         
               {configs.membership.planType==='PERSONAL' &&    <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800 bg-gray-200 rounded-full dark:bg-gray-700 dark:text-gray-300">PERSONAL</span> } 
               
               {configs.membership.planType==='PRO' &&    <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800 bg-gray-200 rounded-full dark:bg-gray-700 dark:text-gray-300">PRO</span> }
               
                </a>
               
             
         </li>
         <li onClick={()=>{navigateTo('/dashboard/bioLinks')}}>
            <button type="button" class="flex items-center w-full p-2 text-base font-normal text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700" aria-controls="dropdown-example" data-collapse-toggle="dropdown-example">
                  <svg aria-hidden="true" class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd"></path></svg>
                  <span class="flex-1 ml-3 text-left whitespace-nowrap">Bio Links</span>
                </button>
           
         </li>
         <li>
            <a onClick={()=>{navigateTo('/dashboard/secure')}} class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"></path><path d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"></path></svg>
               <span class="flex-1 ml-3 whitespace-nowrap">Secure Links</span>
            </a>
         </li>
         <li onClick={()=>{message.info('Analytics is coming soon !')}}>
            <a  class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path><path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path></svg>
               <span class="ml-3">Analytics</span>
            </a>
         </li>

         <li>
            <a onClick={()=>{navigateTo('/dashboard/upgrade')}} class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"></path></svg>
               <span class="flex-1 ml-3 whitespace-nowrap">Upgrade</span>
            </a>
         </li>
        
         <li onClick={()=>{handleLogout()}}>
            <a href="#" class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z" clipRule="evenodd"></path></svg>
               <span class="flex-1 ml-3 whitespace-nowrap">Logout</span>
            </a>
         </li>
      </ul>
   </div>
    </div>
    <nav class="bg-white border-gray-200 px-1 sm:px-4 py-2.5 rounded dark:bg-gray-900">
      <div class="container flex flex-wrap items-center">
        <div style={{cursor:'pointer'}} onClick={()=>{toggleSidebar()}}>
        <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg>

        </div>
        <span style={{position:'absolute',right:20,top:5}}> <BellFilled /></span>
       
    
      </div>
      
    </nav></div>
  )
}
